import { TYPOGRAPHY } from './Typographys';

export const PRIVACY_CONFIG = [
  {
    heading: {
      text: 'A legal disclaimer',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'This Privacy Policy applies to all personal information collected by SurpasIn Pty Ltd (we, us or our) via the website located at Www.surpassin.com (Website).',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'What information do we collect?',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'The kind of Personal Information that we collect from you will depend on how you use the website. The Personal Information which we collect and hold about you may include:',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'When you register, subscribe, or use our services, we may collect:',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
    description: {
      text: [
        'Name, email address, phone numbers, goals, values, strengths and weaknesses',
        'Job title, company name (for B2B users)',
        'Payment and billing information (if applicable)',
        'Any other information you provide in your profile, assessments, or communications',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Types of information',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'The Privacy Act 1998 (Cth) (Privacy Act) defines types of information, including Personal Information and Sensitive Information.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Personal Information means information or an opinion about an identified individual or an individual who is reasonably identifiable:',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
    description: {
      text: [
        '(a) whether the information or opinion is true or not; and',
        '(b) whether the information or opinion is recorded in a material form or not.',
        'If the information does not disclose your identity or enable your identity to be ascertained, it will in most cases not be classified as "Personal Information" and will not be subject to this privacy policy.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: "Sensitive Information is defined in the Privacy Act as including information or opinion about such things as an individual's racial or ethnic origin, political opinions, membership of a political association, religious or philosophical beliefs, membership of a trade union or other professional body, criminal record or health information.",
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
    description: {
      text: [
        'Sensitive Information will be used by us only:',
        '(a) for the primary purpose for which it was obtained;',
        '(b) for a secondary purpose that is directly related to the primary purpose; and',
        '(c) with your consent or where required or authorised by law.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'How we collect your Personal Information',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) We may collect Personal Information from you whenever you input such information into the Website, related app or provide it to Us in any other way.',
        '(b) We may also collect cookies from your computer which enable us to tell when you use the Website and also to help customise your Website experience. As a general rule however, it is not possible to identify you personally from our use of cookies.',
        '(c) We use different types of cookies including essential cookies for Website functionality, analytical cookies to improve user experience, and marketing cookies that may be set by third parties. These cookies are retained for up to [DAYS] days and can be managed through your browser settings. Third-party cookies are subject to their respective privacy policies, which we encourage you to review.',
        '(d) We generally don’t collect Sensitive Information, but when we do, we will comply with the preceding paragraph.',
        '(e) Where reasonable and practicable we collect your Personal Information from you only. However, sometimes we may be given information from a third party, in cases like this we will take steps to make you aware of the information that was provided by a third party.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Purpose of collection',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) We collect Personal Information to provide you with the best service experience possible on the Website and keep in touch with you about developments in our business.',
        '(b) We customarily only disclose Personal Information to our service providers who assist us in operating the Website. Your Personal Information may also be exposed from time to time to maintenance and support personnel acting in the normal course of their duties.',
        '(c) By using our Website, you consent to the receipt of direct marketing material. We will only use your Personal Information for this purpose if we have collected such information direct from you, and if it is material of a type which you would reasonably expect to receive from us. We do not use sensitive Personal Information in direct marketing activity. Our direct marketing material will include a simple means by which you can request not to receive further communications of this nature, such as an unsubscribe button link.',
        '(d) You can manage your marketing preferences through your account settings or by contacting our Privacy Officer. We will process opt-out requests within [DAYS] business days and maintain records of your preferences. Marketing communications will not exceed [NUMBER] messages per month, and each communication will clearly display preference management options. If you choose to opt-out, we will retain minimal Personal Information necessary to ensure compliance with your request.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Security, Access and correction',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) We store your Personal Information in a way that reasonably protects it from unauthorised access, misuse, modification or disclosure. When we no longer require your Personal Information for the purpose for which we obtained it, we will take reasonable steps to destroy and anonymize or de-identify it. Most of the Personal Information that is stored in our client files and records will be kept for a maximum of 7 years to fulfill our record keeping obligations. We implement industry-standard security measures including encryption, access controls, and secure data centers to protect your Personal Information. When deletion is required, we use secure erasure methods including digital shredding and physical destruction of storage media. For digital records, we employ [DAYS] day retention periods for active data and [DAYS] years for archived data, after which automated purge protocols permanently remove the information using government-approved secure deletion standards.',
        '(b) The Australian Privacy Principles:',
        '(i) permit you to obtain access to the Personal Information we hold about you in certain circumstances (Australian Privacy Principle 12); and',
        '(ii) allow you to correct inaccurate Personal Information subject to certain exceptions (Australian Privacy Principle 13).',
        '(c) Where you would like to obtain such access, please contact us in writing on the contact details set out at the bottom of this privacy policy.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Complaint procedure',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'If you have a complaint concerning the manner in which we maintain the privacy of your Personal Information, please contact us on the contact details set out at the bottom of this policy. All complaints will be considered by Richard Austin and we may seek further information from you to clarify your concerns. If we agree that your complaint is well founded, we will, in consultation with you, take appropriate steps to rectify the problem. If you remain dissatisfied with the outcome, you may refer the matter to the Office of the Australian Information Commissioner.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Documentation and Response Timeline',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'We will acknowledge receipt of your complaint within [DAYS] business days and provide you with a reference number. Our privacy team will investigate your complaint and maintain detailed records of all communications and findings. We aim to resolve all privacy complaints within [DAYS] business days. If additional time is required, we will notify you in writing. All complaint documentation will be retained for [DAYS] months following resolution. If the matter requires escalation, our Privacy Officer will personally review your case within [DAYS] business days of the escalation request.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Overseas transfer',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: "Your Personal Information may be transferred overseas or stored overseas for a variety of reasons. It is not possible to identify each and every country to which your Personal Information may be sent. If your Personal Information is sent to a recipient in a country with data protection laws which are at least substantially similar to the Australian Privacy Principles, and where there are mechanisms available to you to enforce protection of your Personal Information under that overseas law, we will not be liable for a breach of the Australian Privacy Principles if your Personal Information is mishandled in that jurisdiction. If your Personal Information is transferred to a jurisdiction which does not have data protection laws as comprehensive as Australia's, we will take reasonable steps to secure a contractual commitment from the recipient to handle your information in accordance with the Australian Privacy Principles.",
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'How to contact us about privacy',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'If you have any queries, or if you seek access to your Personal Information, or if you have a complaint about our privacy practices, you can contact us through: Admin@surpassin.com',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
];
